// removed by extract-text-webpack-plugin
module.exports = {"Oyster":"#C0C5C9","White":"#FFFFFF","Bluecheese":"#615CFF","cta":"G2e3809 Gdfc2b9","isDisabled":"G92e5e5","isFullWidth":"Ge29a05"};